import { CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, Radio, Button, RadioGroup, Stack, TableContainer, Typography, TextField as MuiTextField } from '@mui/material'
import { Box } from '@mui/system'
import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { jobActions } from '../../../redux/reducers/job-slice'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';
import { useEffect } from 'react'
import { useState } from 'react'
import useAxiosPrivate from '../../../hooks/use-axios-private'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material'
import { alertMsg } from '../../../utils/basicUtils'
import { authActions } from '../../../redux/reducers/auth-slice'
import useAuth from '../../../hooks/use-auth'
import { APP_CURRENCY } from '../../../constants'

const ReviewStep = ({ enableNext, saveJobToDraft }) => {
    const { user } = useAuth();
    const job = useSelector(state => state.job)
    const itemData = [...job.media]
    const [summary, setSummary] = useState(false)
    const dispatch = useDispatch()
    const axios = useAxiosPrivate()
    const [wallet, setWallet] = useState(0)
    const [turnAroundTime, setTurnAroundTime] = useState(false)
    const [turnAroundTimeDefaultValue, setTurnAroundTimeDefaultValue] = useState(0)
    const [couponButton, setCouponButton] = useState("Apply")
    const [couponCode, setCouponCode] = useState('')
    const isCouponApplied = useRef(false)

    const reviewJobSummary = async (turnaround, loader = true) => {
        try {
            if (loader) {
                setSummary(false)
            }
            const job_summary = {
                "draft_id": job.draft_id,
                "turn_around_time_id": turnaround,
                "coupon_code": job.coupon_code,
                "user_id": job.user_id
            }

            await saveJobToDraft(job)
            const response = await axios.post(!isCouponApplied.current ? "jobs/summary/" : "jobs/apply_coupon/", job_summary)
            setSummary(response.data.data.summary)
            dispatch(jobActions.addSummary(response.data.data.summary))
        }
        catch (error) {
            console.error(error)
            isCouponApplied.current = false
            setCouponButton("Apply")
            setCouponCode('')
            dispatch(jobActions.addCouponCode(''))
        }
    }
    const handleTurnAroundChange = (e) => {
        setTurnAroundTimeDefaultValue(e.target.value)
        const selectedTurnAround = +e.target.value
        for (let time of turnAroundTime) {
            if (selectedTurnAround === time.duration) {
                dispatch(jobActions.updateTurnAround(time.id))
                reviewJobSummary(time.id)
                break
            }
        }
    }
    const getAvailableCredits = async () => {
        try {
            const response = await axios.get("users/wallet/")
            dispatch(authActions.updateWallet(response.data.data.wallet))
            setWallet(response.data.data.wallet)
        }
        catch (error) {
            console.error(error)
        }
    }
    const getTurnAroundTimeList = async (loader = true) => {
        try {
            let resp = await axios.get('jobs/get_turn_around_time/', {
                params: {
                    image_count: job.output_file_count
                }
            });
            if (resp.data.data.turn_around_time.turn_around_time_lst.length > 0) {
                setTurnAroundTime(resp.data.data.turn_around_time.turn_around_time_lst)
                setTurnAroundTimeDefaultValue(resp.data.data.turn_around_time.turn_around_time_lst[0].duration)
                dispatch(jobActions.updateTurnAround(resp.data.data.turn_around_time.turn_around_time_lst[0].id))
            } else {
                setSummary({ items: [] })
            }
        }
        catch (err) {
            setTurnAroundTime(false)
            console.error(err)
        }
    }

    useEffect(() => {
        enableNext(true)
        return () => {
            enableNext(false)
        }
    }, [enableNext])

    useEffect(() => {
        if (job.turn_around_time !== 0) {
            reviewJobSummary(job.turn_around_time, false)
        }
    }, [job.coupon_code, job.turn_around_time])

    useEffect(() => {
        getAvailableCredits();
        getTurnAroundTimeList();
    }, [])

    const theme = useTheme();
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "end", pt: 1 }}>
                <Typography sx={{ fontWeight: 500, fontSize: { xs: 18, xl: 20 }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Available Credits :{APP_CURRENCY.currency_symbol} {user.wallet.wallet_amount}</Typography>
            </Box>
            {turnAroundTime
                ?
                <Box sx={{ border: "1px solid #e0e0e0", p: 2, borderRadius: "6px", mb: 3, mt: 2 }}>
                    <Grid container alignItems="stretch" spacing={2}>
                        <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label" sx={{ fontSize: { xs: "14px", lg: "16px" } }} > Turn Around Time</FormLabel>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={turnAroundTimeDefaultValue}
                                    onChange={e => { handleTurnAroundChange(e) }}
                                >
                                    {
                                        turnAroundTime.map(
                                            (time, index) =>
                                                <FormControlLabel key={index} value={time.duration} control={<Radio />} label={`${time.duration} H`} />
                                        )
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "end" }}>
                            <Stack direction="column" alignItems="end" justifyContent="center">
                                <Box>
                                    <Typography variant="body1" color="text.secondary" sx={{ mb: 1, fontSize: 14 }} >Apply Coupon Code</Typography>
                                    <Stack direction="row" alignItems="center">
                                        <MuiTextField
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: { xs: 150, md: 200 } }}
                                            InputProps={{
                                                style: {
                                                    borderRadius: "5px",
                                                }
                                            }}
                                            placeholder="Coupon code"
                                            value={couponCode}
                                            onChange={(e) => setCouponCode(e.target.value)}
                                            disabled={couponButton === "Remove"}
                                        />
                                        <Button
                                            variant="contained"
                                            endIcon={<LocalOfferOutlinedIcon sx={{ color: "#FFF" }} />}
                                            color="primary" sx={{ borderRadius: 1, height: 40, border: 0, fontSize: 13, ml: 1 }}
                                            onClick={() => {
                                                if (couponButton === 'Apply') {
                                                    if (couponCode === '') {
                                                        alertMsg("Enter the coupon code", "warning")
                                                    }
                                                    else {
                                                        isCouponApplied.current = true
                                                        dispatch(jobActions.addCouponCode(couponCode))
                                                        setCouponButton('Remove')
                                                    }
                                                }
                                                else {
                                                    isCouponApplied.current = false
                                                    setCouponCode('')
                                                    setCouponButton('Apply')
                                                    dispatch(jobActions.addCouponCode(''))
                                                }
                                            }}
                                        >
                                            {couponButton}
                                        </Button>
                                    </Stack>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
                :
                <Grid container spacing={{ xs: 2, mt: 1, mb: 3 }}>
                    <Grid item xs={12}>
                        <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ebecf0", borderRadius: "6px" }}>
                            <CircularProgress />
                        </Box>
                    </Grid>
                </Grid>
            }
            {
                summary
                    ?
                    <TableContainer component={Paper} sx={{ boxShadow: '2px 2px 12px 0px rgb(0 0 0 / 11%)' }}>
                        <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                            <TableHead>
                                <TableRow sx={{ background: theme.palette.primary.main }}>
                                    <TableCell sx={{ color: "primary.contrastText" }} align='center'>SL</TableCell>
                                    <TableCell sx={{ color: "primary.contrastText" }} align='center'>Title</TableCell>
                                    <TableCell sx={{ color: "primary.contrastText" }} align='center'>Price({APP_CURRENCY.currency_symbol})</TableCell>
                                    <TableCell sx={{ color: "primary.contrastText" }} align='center'>Image Count</TableCell>
                                    <TableCell sx={{ color: "primary.contrastText" }} align='center'>Total({APP_CURRENCY.currency_symbol})</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* {summary && */}
                                {summary.items.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell align='center'>{index + 1}</TableCell>
                                        <TableCell align='center'>{item.title}</TableCell>
                                        <TableCell align='center'>{item.item_price}</TableCell>
                                        {item.file_count
                                            ?
                                            <TableCell align='center'>{item.file_count}</TableCell>
                                            :
                                            <TableCell align='center'>--</TableCell>
                                        }
                                        <TableCell align='center'>{item.item_total}</TableCell>
                                    </TableRow>
                                ))}

                                <TableRow>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell />
                                    <TableCell align='center' sx={{ fontWeight: "500" }}>Subtotal</TableCell>
                                    <TableCell align='center'>{APP_CURRENCY.currency_symbol} {summary.gross_price}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell />
                                    {summary.coupon_payment
                                        ?
                                        <>
                                            <TableCell align='center' sx={{ fontWeight: "500" }}>
                                                <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
                                                    Discount
                                                    <Tooltip placement='top' title={`${summary.coupon_payment.discount_code}  Coupon code applied`}>
                                                        <InfoIcon />
                                                    </Tooltip>
                                                </Stack>
                                            </TableCell>
                                            <TableCell align='center'>-{APP_CURRENCY.currency_symbol} {summary.coupon_payment.discount}</TableCell>
                                        </>
                                        :
                                        <>
                                            <TableCell align='center' sx={{ fontWeight: "500" }}>Discount</TableCell>
                                            <TableCell align='center'>--</TableCell>
                                        </>
                                    }
                                </TableRow>
                                <TableRow>
                                    <TableCell />
                                    <TableCell />
                                    <TableCell />
                                    <TableCell align='center' sx={{ fontWeight: "500", background: theme.palette.primary.main, color: "primary.contrastText", borderColor: '#3f51b5' }}>Total</TableCell>
                                    <TableCell align='center' sx={{ fontWeight: "500", background: theme.palette.primary.main, color: "primary.contrastText", borderColor: '#3f51b5' }}>{APP_CURRENCY.currency_symbol} {summary.net_price}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    :
                    <Grid container spacing={{ xs: 2, }}>
                        <Grid item xs={12}>
                            <Box sx={{ height: "450px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ebecf0", borderRadius: "6px", mt: 3 }}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    </Grid>
            }
        </>

    )
}

export default ReviewStep